import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'highlight'
})
export class HighlightSearchPipe implements PipeTransform
{
  public transform(value: any, searchTerm: any, discardedItems = ''): any
  {
    if (searchTerm && value && value !== discardedItems)
    {
      const noSpace = /\s*,\s*/;
      const queryList = searchTerm.split(noSpace).filter(String);
      const matchQueries = new RegExp(queryList.join('|'), 'gi');
      return value.replace(matchQueries, (x: string) => '<mark>' + x + '</mark>');
    }
    return value;
  }

}
